<template>
  <div>

    <main role="main">

      <div class="container">

        <div class="row mb-5">

          <div class="col-md-12">

            <h2 class="mb-3">
              <i class="fa fa-search"></i> {{ $t('text.documentSearch.documentSearchDetailed.title') }}
            </h2>

            <div class="form-condensed">

              <DetailedSearchFieldAndValue
                  :fieldAndValue="fieldsAndValues[0]"
                  :searchableFields="$t('text.documentSearch.documentSearchDetailed.searchableFields')"
                  :index="0"
                  :disabled="false"
                  :allMetadataOptions="allMetadataOptions"
                  :key="'item0'"
              ></DetailedSearchFieldAndValue>

              <div class="col-md-2 mb-3 ml-2">
                <div class="form-group">
                  <label for="filterOneOperator">{{ $t('text.documentSearch.documentSearchDetailed.operator') }}</label>
                  <v-select :options="operatorOptions"
                            :reduce="item => item.id"
                            label="description"
                            class="form-control"
                            id="filterOneOperator"
                            v-model="filterOneOperator"
                            @input="onOperatorChange(1)"
                  >
                    <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                  </v-select>
                </div>
              </div>

              <DetailedSearchFieldAndValue
                  :fieldAndValue="fieldsAndValues[1]"
                  :searchableFields="$t('text.documentSearch.documentSearchDetailed.searchableFields')"
                  :index="1"
                  :disabled="isFilterOneOperatorDisabled"
                  :allMetadataOptions="allMetadataOptions"
                  :key="'item1'"
              ></DetailedSearchFieldAndValue>


              <div class="col-md-2 mb-3 ml-2">
                <div class="form-group">
                  <label for="filterTwoOperator">{{ $t('text.documentSearch.documentSearchDetailed.operator') }}</label>
                  <v-select :options="operatorOptions" :reduce="item => item.id"
                            label="description" class="form-control"
                            id="filterTwoOperator"
                            v-model="filterTwoOperator"
                            @input="onOperatorChange(2)"
                  >
                    <span slot="no-options">{{ $t('text.globals.noOptions') }}</span>
                  </v-select>
                </div>
              </div>

              <DetailedSearchFieldAndValue
                  :fieldAndValue="fieldsAndValues[2]"
                  :searchableFields="$t('text.documentSearch.documentSearchDetailed.searchableFields')"
                  :index="2"
                  :disabled="isFilterTwoOperatorDisabled"
                  :allMetadataOptions="allMetadataOptions"
                  :key="'item2'"
              ></DetailedSearchFieldAndValue>

            </div>

            <a class="btn btn-primary text-white mt-5" @click="submitQuery(true)" id="buttonSearchQuery"><i
                class="fa fa-search"></i> {{ $t('text.globals.search')}} </a>


            <a class="btn btn-primary text-white mt-5" @click="clearSearch()" id="buttonClearFilters">
              {{ $t('text.globals.clearAllFilters')}} </a>

          </div>
        </div>

        <div class="row" v-if="selectedDocuments.length > 0">
          <div class="col-md-12">
            <div class="bg-light p-4">
              <div>
                <div class="mb-2"><i class="fa fa-check-square"></i> {{$t('text.documentLists.selectedDocuments')}}: <b>{{selectedDocuments.length}}</b>
                  <a class="btn btn-secondary btn-sm text-white ml-3"
                     @click="selectAll()">{{ $t('text.documentLists.selectAll') }}</a>
                  <a class="btn btn-secondary btn-sm text-white ml-3"
                     @click="unselectAll()">{{ $t('text.documentLists.deselectAll') }}</a></div>
              </div>
            </div>
          </div>
        </div>

        <div>

          <loading :active.sync="isLoading"
                   :can-cancel="false"
                   :is-full-page="false"></loading>

          <!--                    <SearchResults-->
          <!--                            :queryResult="queryResult"-->
          <!--                            :filtersQuery="filtersQuery"-->
          <!--                            :columns="columns"-->
          <!--                            :context="context"-->
          <!--                            :totalRecords="totalRecords"-->
          <!--                            :serverParams="serverParams"-->
          <!--                    ></SearchResults>-->


          <SearchResultsWithSelection
              ref="searchResultsWithSelection"
              :searchType="$t('text.documentSearch.documentSearchDetailed.title')"
              :query="query"
              :searchFieldsText="[
                                {
                                'operator': filterOneOperator,
                                'parameter': filterOneField,
                                'value': filterOneValue,
                                'vpisniki': filterOneVpisnikiValue
                                },
                                {
                                'operator': filterTwoOperator,
                                'parameter': filterTwoField,
                                'value': filterTwoValue,
                                'vpisniki': filterTwoVpisnikiValue
                                },
                                {
                                'operator': filterThreeField ? 'AND' : '',
                                'parameter': filterThreeField,
                                'value': filterThreeValue,
                                'vpisniki': filterThreeVpisnikiValue
                                }
                            ]"
              :queryResult="queryResult"
              :filtersQuery="filtersQuery"
              :columns="columns"
              :context="context"
              :totalRecords="totalRecords"
              :serverParams="serverParams"
              @clearFiltersQuery="clearFiltersQuery"
          ></SearchResultsWithSelection>

        </div>
      </div>

    </main>

  </div>
</template>

<script type="text/javascript">
import Vue from 'vue';
import SearchResults from '../components/SearchResults';
import axios from 'axios';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import DetailedSearchFieldAndValue from '../components/DetailedSearchFieldAndValue';
import SearchResultsWithSelection from "../components/SearchResultsWithSelection";


export default {
  name: 'DocumentSearchFullText',
  components: {
    DetailedSearchFieldAndValue,
    SearchResults,
    SearchResultsWithSelection,
    vSelect,
    Loading
  },

  data() {
    return {
      query: '',
      filtersQuery: [],
      context: {},
      sites: [],
      user: {},
      error: '',

      selectedDocuments: [],
      selectedDocumentsList: [],

      filterOneField: '',
      filterOneOptions: [],
      filterOneValue: '',
      filterOneOperator: null,
      filterTwoField: '',
      filterTwoOptions: [],
      filterTwoValue: '',
      filterTwoOperator: null,
      filterThreeField: '',
      filterThreeOptions: [],
      filterThreeValue: '',
      filterOneVpisnikiValue: '',
      filterTwoVpisnikiValue: '',
      filterThreeVpisnikiValue: '',


      fieldsAndValues: [
        {
          filterField: null,
          filterValue: null,
          filterVpisnikiValue: null,
        },
        {
          filterField: null,
          filterValue: null,
          filterVpisnikiValue: null,
        },
        {
          filterField: null,
          filterValue: null,
          filterVpisnikiValue: null
        },
      ],
      operatorOptions: this.$t('text.documentSearch.documentSearchDetailed.operatorOptions'),

      isLoading: false,
      totalRecords: null,
      serverParams: {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: this.$store.getters.getItemsPerPage
      },
      queryResult: [],
      columns: _.cloneDeep(this.$globalFunctions.getListColumns('searchResults')),
      allMetadataOptions: [],
      metadataSearchValues: {}
    };
  },

  beforeCreate: function () {
    document.body.className = 'dashboard';
  },


  beforeRouteLeave: function (to, from, next) {
    // clear search field values for all other routes than DocumentDetails
    if (to.name === 'DocumentDetails') {
      next();
    } else {
      console.log("HERE!!!");
      this.$store.dispatch("setMetadataSearchValues", {}).then(() => {
        next();
      });
    }
  },


  mounted() {
    const _this = this;

    let p1 = _this.$store.dispatch("retrieveAllMetadataOptions");

    Promise.all([p1]).then((values) => {
      _this.allMetadataOptions = _this.$store.getters.getAllMetadataOptions;


      if(_this.$route.query.urlQueryParams != null) {
        let urlQueryParams = JSON.parse(atob(_this.$route.query.urlQueryParams));
        _this.metadataSearchValues = urlQueryParams.searchParams || null;
        _this.serverParams = urlQueryParams.paginationParams || null;
        _this.filtersQuery = urlQueryParams.filtersQueryParams || null;
      }

      console.log("_this.metadataSearchValues", _this.metadataSearchValues);

      // console.log("QUERYPARAMS::::", JSON.parse(atob(_this.$route.query.searchParams)));

      // load saved filters
      if (Object.keys(_this.metadataSearchValues).length > 0) {
        _this.fieldsAndValues[0].filterField = _this.metadataSearchValues.filterOneField;
        _this.fieldsAndValues[1].filterField = _this.metadataSearchValues.filterTwoField;
        _this.fieldsAndValues[2].filterField = _this.metadataSearchValues.filterThreeField;

        _this.fieldsAndValues[0].filterValue = _this.metadataSearchValues.filterOneValue;
        _this.fieldsAndValues[1].filterValue = _this.metadataSearchValues.filterTwoValue;
        _this.fieldsAndValues[2].filterValue = _this.metadataSearchValues.filterThreeValue;

        _this.fieldsAndValues[0].filterVpisnikiValue = _this.metadataSearchValues.filterOneVpisnikiValue;
        _this.fieldsAndValues[1].filterVpisnikiValue = _this.metadataSearchValues.filterTwoVpisnikiValue;
        _this.fieldsAndValues[2].filterVpisnikiValue = _this.metadataSearchValues.filterThreeVpisnikiValue;

        // let filterOneVpisnikiValue = _.map(_this.metadataSearchValues.filterOneVpisnikiValue, function(item) { console.log("item", item); return { id: item, description: _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_vpisnika', item)} }); // _this.metadataSearchValues.filterOneVpisnikiValue;
        // let filterTwoVpisnikiValue = _.map(_this.metadataSearchValues.filterTwoVpisnikiValue, function(item) { return { id: item, description: _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_vpisnika', item)} }); //_this.metadataSearchValues.filterTwoVpisnikiValue;
        // let filterThreeVpisnikiValue = _.map(_this.metadataSearchValues.filterThreeVpisnikiValue, function(item) { return { id: item, description: _this.$globalFunctions.getReadableCodeListValueFromProperty(_this.allMetadataOptions, 'EH:oznaka_vpisnika', item)} }); //_this.metadataSearchValues.filterThreeVpisnikiValue;
        //
        // _this.fieldsAndValues[0].filterVpisnikiValue = filterOneVpisnikiValue;
        // _this.fieldsAndValues[1].filterVpisnikiValue = filterTwoVpisnikiValue;
        // _this.fieldsAndValues[2].filterVpisnikiValue = filterThreeVpisnikiValue;

        //console.log("filterOneVpisnikiValue", filterOneVpisnikiValue);
        console.log("-----> ", _this.fieldsAndValues);


        _this.filterOneOperator = _this.metadataSearchValues.filterOneOperator;
        _this.filterTwoOperator = _this.metadataSearchValues.filterTwoOperator;


        _this.submitQuery(false);
      }
    });

  },
  computed: {

    isFilterOneOperatorDisabled() {
      return (this.filterOneOperator == null);

    },
    isFilterTwoOperatorDisabled() {
      return (this.filterTwoOperator == null);
    },


  },
  methods: {

    clearFiltersQuery() {
      this.filtersQuery = [];
    },

    clearSearch() {

      // query fields
      this.fieldsAndValues = [
        {
          filterField: null,
          filterValue: null,
          filterVpisnikiValue: null,
        },
        {
          filterField: null,
          filterValue: null,
          filterVpisnikiValue: null,
        },
        {
          filterField: null,
          filterValue: null,
          filterVpisnikiValue: null
        },
      ];
      this.filterOneOperator = null;
      this.filterTwoOperator = null;


      this.selectedDocuments = [];
      this.$store.dispatch("setSelectedDocuments", []);

      this.filtersQuery = [];
      this.totalRecords = null;
      this.serverParams = {
        columnFilters: {},
        sort: [],
        page: 1,
        perPage: this.$store.getters.getItemsPerPage
      };
      this.queryResult = [];
      this.context = {};
      this.isLoading = false;
      this.query = '';

      this.columns = _.cloneDeep(this.$globalFunctions.getListColumns('searchResults'));

      // url change
      this.$router.replace({
        name: 'DocumentSearchDetailed',
      }).catch(err => {
      });

    },

    onOperatorChange(index) {
      if (index == 1) {
        if (this.filterOneOperator == null) {
          this.fieldsAndValues[1] = {
            filterField: null,
            filterValue: null,
          };
        }
      } else {
        if (this.filterTwoOperator == null) {
          this.fieldsAndValues[2] = {
            filterField: null,
            filterValue: null,
          };
        }
      }


    },

    updateParams(newProps) {
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },

    onPageChange(params) {
      const _this = this;

      _this.isLoading = true;

      console.log("onPageChange", params);

      _this.updateParams({page: params});
      setTimeout(function () {
        _this.submitQuery();
      }, 1)

    },

    onPerPageChange() {
      const _this = this;
      _this.updateParams({perPage: _this.$store.getters.getItemsPerPage});
      setTimeout(function () {
        _this.submitQuery(true);
      }, 1)
    },

    onSortChange(params) {
      const _this = this;

      _this.isLoading = true;

      let sort = [];

      _.map(_this.columns, function (item, i) {

        console.log(item);

        if (item.sort && typeof (item.sort.ascending) !== 'undefined') {

          let sortItem = {
            'ascending': item.sort.ascending ? 'true' : 'false',
            'field': _this.$globalFunctions.formatFieldNameForSort(item.field),
            'type': 'FIELD'
          };

          sort.push(sortItem);

        }
      });

      _this.updateParams({
        sort: sort,
      });

      setTimeout(function () {
        _this.submitQuery();
      }, 1);


    },

    onColumnFilter(params) {
      const _this = this;
      _this.updateParams(params);
      setTimeout(function () {
        _this.submitQuery();
      }, 1)
    },


    submitQuery(newSearch) {

      let _this = this;

      _this.isLoading = true;
      _this.queryResult = [];
      _this.selectedDocuments = [];

      console.log(_this.serverParams);


      let queryStringOne = "";
      let queryStringTwo = "";
      let queryStringThree = "";


      _this.filterOneField = _this.fieldsAndValues[0].filterField;
      _this.filterTwoField = _this.fieldsAndValues[1].filterField;
      _this.filterThreeField = _this.fieldsAndValues[2].filterField;

      _this.filterOneValue = _this.fieldsAndValues[0].filterValue;
      _this.filterTwoValue = _this.fieldsAndValues[1].filterValue;
      _this.filterThreeValue = _this.fieldsAndValues[2].filterValue;

      _this.filterOneVpisnikiValue = _this.fieldsAndValues[0].filterVpisnikiValue;
      _this.filterTwoVpisnikiValue = _this.fieldsAndValues[1].filterVpisnikiValue;
      _this.filterThreeVpisnikiValue = _this.fieldsAndValues[2].filterVpisnikiValue;


      if (_this.filterOneField === "EH:kljucne_besede" || _this.filterTwoField === "EH:kljucne_besede" || _this.filterThreeField === "EH:kljucne_besede") {
        let filterOneValueKeywords = _this.updateKeywordQuery(_this.filterOneField, _this.filterOneValue);
        let filterTwoValueKeywords = _this.updateKeywordQuery(_this.filterTwoField, _this.filterTwoValue);
        let filterThreeValueKeywords = _this.updateKeywordQuery(_this.filterThreeField, _this.filterThreeValue);

        queryStringOne = filterOneValueKeywords ? (_this.filterOneField + ":" + "(" + filterOneValueKeywords + ")") : '';
        queryStringTwo = filterTwoValueKeywords ? ((_this.filterOneOperator ? _this.filterOneOperator + ' ' : '') + _this.filterTwoField + ":" + "(" + filterTwoValueKeywords + ")") : '';
        queryStringThree = filterThreeValueKeywords ? ((_this.filterTwoOperator ? _this.filterTwoOperator + ' ' : '') + _this.filterThreeField + ":" + "(" + filterThreeValueKeywords + ")") : '';
      } else if (_this.filterOneField) {
        if (_this.isDateField(_this.filterOneField)) {
          queryStringOne = _this.filterOneValue ? (_this.filterOneField + ":[\'" + _this.moment(_this.filterOneValue.start, 'YYYY-MM-DD').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z\' TO \'" + _this.moment(_this.filterOneValue.end, 'YYYY-MM-DD').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS')) + "Z\']" : (_this.filterOneField + ":'*'");
        } else if (_this.filterOneField === "id") {
          _this.filterOneValue = _this.filterOneValue.replace(/['"]+/g, '');
          queryStringOne = _this.filterOneValue ? ('=ID:"workspace://SpacesStore/' + _this.filterOneValue + '"') : '';
        } else if (_this.filterOneField === "rma:ghosted") {
          // skip this field - handeled by "shouldShowDeletedRecords" method
        } else {
          console.log("_this.filterOneValue", _this.filterOneValue);
          let _filterOneValue = _this.filterOneValue;
          if (_filterOneValue && typeof _filterOneValue === 'string') {
            _filterOneValue = _filterOneValue.replace(/['"$&+,:;=?@#|<>.^*()%!-]/g, (char) => '\\' + char);
          } else if (_filterOneValue == '') {
            _filterOneValue = '*';
          }
          queryStringOne = _this.filterOneField + ":" + "\'" + _filterOneValue + "\'";

          if (_this.filterOneField === "EH:oznaka_povezanega_sistema" && _this.filterOneVpisnikiValue.length > 0) {
            queryStringOne = _this.generateVpisnikiSearchQuery(queryStringOne, _this.filterOneVpisnikiValue);
          }
        }

        if (_this.isDateField(_this.filterTwoField)) {
          queryStringTwo = _this.filterTwoValue ? ((_this.filterOneOperator ? _this.filterOneOperator + ' ' : '') + _this.filterTwoField + ":[\'" + _this.moment(_this.filterTwoValue.start, 'YYYY-MM-DD').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z\' TO \'' + _this.moment(_this.filterTwoValue.end, 'YYYY-MM-DD').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z\']") : '';
        } else if (_this.filterTwoField === "id") {
          _this.filterTwoValue = _this.filterTwoValue.replace(/['"]+/g, '');
          queryStringTwo = _this.filterTwoValue ? ((_this.filterOneOperator ? _this.filterOneOperator + ' ' : '') + '=ID:"workspace://SpacesStore/' + _this.filterTwoValue + "'") : '';
        } else if (_this.filterTwoField === "rma:ghosted") {
          // skip this field - handeled by "shouldShowDeletedRecords" method
        } else if (_this.filterTwoField) {
          let _filterTwoValue = _this.filterTwoValue;
          if (_filterTwoValue && typeof _filterTwoValue === 'string') {
            _filterTwoValue = _filterTwoValue.replace(/['"$&+,:;=?@#|<>.^*()%!-]/g, (char) => '\\' + char);
          } else if (_filterTwoValue == '') {
            _filterTwoValue = '*';
          }

          queryStringTwo = ((_this.filterOneOperator ? _this.filterOneOperator + ' ' : '') + _this.filterTwoField + ":" + "\'" + _filterTwoValue + "\'");

          if (_this.filterTwoField === "EH:oznaka_povezanega_sistema" && _this.filterTwoVpisnikiValue.length > 0) {
            queryStringTwo += _this.generateVpisnikiSearchQuery(queryStringTwo, _this.filterTwoVpisnikiValue);
          }
        }

        if (_this.isDateField(_this.filterThreeField)) {
          queryStringThree = _this.filterThreeValue ? ((_this.filterTwoOperator ? _this.filterTwoOperator + ' ' : '') + _this.filterThreeField + ":[\'" + _this.moment(_this.filterThreeValue.start, 'YYYY-MM-DD').startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + 'Z\' TO \'' + _this.moment(_this.filterThreeValue.end, 'YYYY-MM-DD').endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss.SSS') + "Z\']") : '';
        } else if (_this.filterThreeField === "id") {
          _this.filterThreeValue = _this.filterThreeValue.replace(/['"]+/g, '');
          queryStringThree = _this.filterThreeValue ? ((_this.filterTwoOperator ? _this.filterTwoOperator + ' ' : '') + '=ID:"workspace://SpacesStore/' + _this.filterThreeValue + "'") : '';
        } else if (_this.filterThreeField === "rma:ghosted") {
          // skip this field - handeled by "shouldShowDeletedRecords" method
        } else if (_this.filterThreeField) {
          let _filterThreeValue = _this.filterThreeValue;
          if (_filterThreeValue && typeof _filterThreeValue === 'string') {
            _filterThreeValue = _filterThreeValue.replace(/['"$&+,:;=?@#|<>.^*()%!-]/g, (char) => '\\' + char);
          } else if (_filterThreeValue == '') {
            _filterThreeValue = '*';
          }

          queryStringThree = ((_this.filterTwoOperator ? _this.filterTwoOperator + ' ' : '') + _this.filterThreeField + ":" + "\'" + _filterThreeValue + "\'");

          if (_this.filterThreeField === "EH:oznaka_povezanega_sistema" && _this.filterThreeVpisnikiValue.length > 0) {
            queryStringThree += _this.generateVpisnikiSearchQuery(queryStringThree, _this.filterThreeVpisnikiValue);
          }

        }
      }

      // console.log("expressionFromQuery: ", _this.exampleQuery);
      // console.log("skip count: ", (_this.serverParams.page - 1) * _this.serverParams.perPage);


      console.log("queryStringOne", queryStringOne);
      console.log("queryStringTwo", queryStringTwo);
      console.log("queryStringThree", queryStringThree);


      if (queryStringTwo.indexOf('OR') > -1 && (queryStringThree && queryStringThree.indexOf('OR') < 0)) {
        queryStringOne = '(' + queryStringOne;
        queryStringTwo = queryStringTwo + ')';
      }

      if (queryStringThree.indexOf('OR') > -1 && (queryStringTwo && queryStringTwo.indexOf('OR') < 0)) {
        queryStringTwo = 'AND (' + queryStringTwo.replace('AND', '');
        queryStringThree = queryStringThree + ')';
      }


      let query = {
        "query": {
          "query": (queryStringOne ? queryStringOne : "*") + (queryStringTwo ? " " + queryStringTwo : "") + (queryStringThree ? " " + queryStringThree : "")
        },
        "paging": {
          "maxItems": _this.serverParams.perPage,
          "skipCount": newSearch ? 0 : (_this.serverParams.page - 1) * _this.serverParams.perPage
        },
        "include": [
          "properties"
        ],
        "sort": this.$globalFunctions.reformatSortArray(_this.serverParams.sort),
        "facetQueries": _this.$t('text.documentSearch.facetQueries'),
        "facetFields": _this.$t('text.documentSearch.facetFields')
      };

      let filterQueryString = '';

      _.map(_this.filtersQuery, function (val) {
        filterQueryString += ' AND ' + val;
      });

      query.query.query = "(" + query.query.query + ")" + filterQueryString + " AND +TYPE:\'cm:content\'" + " AND +ASPECT:\'EH:osnovni_podatki\'" + this.shouldShowDeletedRecords();
      _this.query = query.query.query;

      _this.metadataSearchValues = {
        filterOneField: _this.filterOneField,
        filterTwoField: _this.filterTwoField,
        filterThreeField: _this.filterThreeField,
        filterOneValue: _this.filterOneValue,
        filterTwoValue: _this.filterTwoValue,
        filterThreeValue: _this.filterThreeValue,
        filterOneOperator: _this.filterOneOperator,
        filterTwoOperator: _this.filterTwoOperator,
        filterOneVpisnikiValue: _this.filterOneVpisnikiValue,
        filterTwoVpisnikiValue: _this.filterTwoVpisnikiValue,
        filterThreeVpisnikiValue: _this.filterThreeVpisnikiValue
      };

      // _this.$store.dispatch("setMetadataSearchValues", _this.metadataSearchValues);
      //


      axios.post(config.alfrescoSearchApi, query)
          .then((res) => {
            _this.totalRecords = res.data.list.pagination.totalItems;
            _this.serverParams.page = res.data.list.pagination.skipCount / _this.serverParams.perPage + 1;
            _this.queryResult = res.data.list.entries;
            _this.context = res.data.list.context;
            _this.isLoading = false;

            setTimeout(function () {
              document.documentElement.scrollTop = _this.$store.getters.getOffsetTop;
              _this.$store.dispatch("setOffsetTop", null);
            }, 1);


            console.log("!!!!!!! PRE ROUTER PUSH ", _this.serverParams);

            let urlQueryParams = {
              searchParams:  _this.metadataSearchValues,
              paginationParams: _this.serverParams,
              filtersQueryParams: _this.filtersQuery
            };


            _this.$router.push({
              name: 'DocumentSearchDetailed',
              query:  {urlQueryParams: btoa(JSON.stringify(urlQueryParams))},
            }).catch(err => {
            });
            console.log("POST ROUTER PUSH ");

          })
          .catch((error) => {
            console.log("error", error);
          });


    },

    updateKeywordQuery(filterField, filterValue) {

      if (filterField === "EH:kljucne_besede") {

        let newFilterQuery = "";

        filterValue = filterValue.trim();
        let keywords = filterValue.split(",");

        for (let i = 0; i < keywords.length; i++) {

          let currentTrimmedKeyword = keywords[i].trim();


          if (i != keywords.length - 1) {
            newFilterQuery += "*" + currentTrimmedKeyword + (currentTrimmedKeyword ? "*" : "") + " OR ";
          } else {
            newFilterQuery += "*" + currentTrimmedKeyword + (currentTrimmedKeyword ? "*" : "");
          }


        }

        filterValue = newFilterQuery;
      }

      return filterValue;
    },

    onRowClick(row) {
      let _this = this;

      console.log(row);
      if (!_this.$globalFunctions.checkForPermission('DOST_DOK_IN_META') && !_this.$globalFunctions.checkForPermission('DOST_DOK_ARHIV')) {
        console.error("No permission for DOST_DOK_IN_META || DOST_DOK_ARHIV");
        return
      }

      let id = row.id;

      if (row.isFile) {
        _this.$router.push("/dokument/" + id);
      } else {
        Vue.$toast.open({
          message: this.$t('text.documentSearch.documentSearchDetailed.openingEnabledJustForFilesErrorToast'),
          type: 'error',
          position: 'top-right'
        });
      }

    },

    onCheckboxClick($event, uuid) {
      let _this = this;

      $event.stopPropagation();

      if (_this.selectedDocuments.indexOf(uuid) > -1) {
        _this.selectedDocuments.splice(_this.selectedDocuments.indexOf(uuid), 1);
      } else {
        _this.selectedDocuments.push(uuid);
      }

      _this.generateSelectedDocumentList();
      _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);


      console.log(_this.selectedDocuments);

      console.log("uuid", uuid);

    },

    onThCheckboxClick($event) {
      let _this = this;
      $event.stopPropagation();

      const checkboxItem = $event.target.id === "selectAllTh" ? $event.target.querySelector("#selectAllCheckbox") : $event.target;

      if (checkboxItem.checked) {
        console.log("select all documents!");
        _.map(_this.queryResult, function (val) {
          if (_this.selectedDocuments.indexOf(val.entry.id) === -1) {
            _this.selectedDocuments.push(val.entry.id);
          }
        });
      } else {
        console.log("DEselect all documents!");
        _this.selectedDocuments = [];
      }

      _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
    },

    generateSelectedDocumentList() {
      const _this = this;
      _this.selectedDocumentsList = [];

      _.map(_this.selectedDocuments, function (val) {
        _.map(_this.queryResult, function (_val) {
          if (_val.entry.id === val) {
            _this.selectedDocumentsList.push(_val.entry);
          }
        });
      });
    },

    generateVpisnikiSearchQuery(queryString, filterVpisnikiValue) {
      const _this = this;

      _.each(filterVpisnikiValue, function (vpisnikId, i) {
        console.log("i", i);
        if (i === 0) {
          if (filterVpisnikiValue.length > 1) {
            queryString += ' AND (EH:oznaka_vpisnika:' + vpisnikId;
          } else {
            queryString += ' AND EH:oznaka_vpisnika:' + vpisnikId;
          }
        } else {
          if (i === filterVpisnikiValue.length - 1) {
            queryString += ' OR EH:oznaka_vpisnika:' + vpisnikId + ')';
          } else {
            queryString += ' OR EH:oznaka_vpisnika:' + vpisnikId;
          }

        }
      });

      return queryString

    },

    isDateField(field) {
      let dateFields = [
        'EH:datum_gradiva',
        'EH:datum_izteka_roka_hrambe',
        'EH:datum_pregleda_izrocanje',
        'EH:datum_pregleda',
        'EH:format_datum_preverbe',
        'EH:datum_unicenja',
        'EH:datum_zacetka_teka_roka_hrambe',
        'EH:izroceno_dne',
        'EH:datum_zadnje_spremembe_statusa_gradiva',
      ];
      return dateFields.includes(field);
    },

    shouldShowDeletedRecords() {
      const _this = this;

      if ((_this.filterOneField === "rma:ghosted" && _this.filterOneValue === 'true') || (_this.filterTwoField === "rma:ghosted" && _this.filterTwoValue === 'true') || (_this.filterThreeField === "rma:ghosted" && _this.filterThreeValue === 'true')) {
        return ' AND ASPECT:"rma:ghosted"';
      } else {
        return ' AND NOT ASPECT:"rma:ghosted"';
      }
    },

    unselectAll() {
      const _this = this;

      _this.selectedDocuments = [];
      _this.selectedDocumentsList = [];
      _this.$store.dispatch("setSelectedDocuments", []);
      _this.$refs.searchResultsWithSelection.checkIfHeaderCheckboxShouldBeChecked();
    },

    selectAll() {
      const _this = this;

      _.map(_this.queryResult, function (val) {
        if(_this.selectedDocuments.indexOf(val.entry.id) === -1) {
          _this.selectedDocuments.push(val.entry.id);
        }
      });

      _this.$store.dispatch("setSelectedDocuments", _this.selectedDocuments);
    }


  }


};
</script>



// WEBPACK FOOTER //
// src/pages/DocumentSearchDetailed.vue